/**
 * LECTURE BRUTE D'UN FICHIER EN BASE64 — face WEB.
 *
 * `expo-file-system` N'A PAS D'IMPLÉMENTATION WEB : son module s'y réduit à un talon dont le
 * constructeur écrit un avertissement, et `base64()` n'y existe tout simplement pas. Tout import de
 * document échouait donc systématiquement sur le web — et, avant les gardes, sans rien afficher.
 *
 * CE QU'ON UTILISE À LA PLACE. Le sélecteur web d'`expo-document-picker` rend une URL `blob:`
 * (`URL.createObjectURL`), que le navigateur sait relire : `fetch` la ramène en `Blob`, et
 * `FileReader.readAsDataURL` en donne une data URL dont on retire le préfixe. C'est exactement ce
 * que fait déjà `expo-image-picker` sur le web pour remplir son champ `base64` — d'où le fait que
 * les captures d'écran, elles, marchaient depuis le début.
 *
 * MÊME CONTRAT QUE LA FACE NATIVE : `null` pour l'échec, jamais d'exception. Le message affiché
 * vient de `mediaPicker.lireDocumentImporte`, pour qu'il n'existe qu'en un seul exemplaire.
 */
export async function lireBase64(uri: string): Promise<string | null> {
  try {
    const reponse = await fetch(uri);
    const blob = await reponse.blob();

    return await new Promise<string>((resolve, reject) => {
      const lecteur = new FileReader();
      lecteur.onerror = () => reject(lecteur.error ?? new Error('lecture interrompue'));
      lecteur.onload = () => {
        const resultat = String(lecteur.result);
        // `data:<mime>;base64,<charge>` — on ne garde que la charge. La virgule est le séparateur
        // défini par la RFC 2397 ; son absence signale une data URL inattendue, pas un fichier vide.
        const virgule = resultat.indexOf(',');
        if (virgule < 0) {
          reject(new Error('data URL inattendue'));
          return;
        }
        resolve(resultat.slice(virgule + 1));
      };
      lecteur.readAsDataURL(blob);
    });
  } catch {
    // URL révoquée, fichier retiré du disque entre la sélection et la lecture, lecture interrompue.
    return null;
  }
}
